module.exports = __webpack_public_path__ + "media/Video 11.3a2a9455.mp4";